import { render } from "./Cohorte.vue?vue&type=template&id=37019047&scoped=true"
import script from "./Cohorte.vue?vue&type=script&lang=js"
export * from "./Cohorte.vue?vue&type=script&lang=js"

import "./Cohorte.vue?vue&type=style&index=0&id=37019047&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37019047"]])

export default __exports__